// Разбиение utm-фразы на слова и агрегация метрик по словам.
// Одна сессия несёт ровно одну utm-фразу (см. stat-back/src/query/dbAdd.js),
// поэтому ses/ch/ch_c по разным фразам можно складывать, а проценты — нет.
// Разбиение идёт по всему, что не буква и не цифра (знаки препинания, "+",
// дефис и т.п. — разделители), поэтому "окна-пвх" даёт два слова: "окна", "пвх".

export function splitPhraseToWords(phrase) {
  const s = String(phrase == null ? '' : phrase).trim().toLowerCase();
  if (!s) return [];
  return [...new Set(s.split(/[^\p{L}\p{N}]+/u).filter(Boolean))];
}

function percent(part, total) {
  if (!total) return '0%';
  return ((part / total) * 100).toFixed(0) + '%';
}

export function aggregateWords(utmObj) {
  // Object.create(null): utm_term приходит от посетителя сайта и может
  // содержать любую строку, включая "__proto__" — обычный {} превратил бы
  // такой ключ в переустановку прототипа вместо обычного свойства.
  const acc = Object.create(null);
  for (const phrase in utmObj) {
    if (!Object.prototype.hasOwnProperty.call(utmObj, phrase)) continue;
    const m = utmObj[phrase] || {};
    for (const word of splitPhraseToWords(phrase)) {
      if (!acc[word]) acc[word] = { ses: 0, ch: 0, ch_c: 0 };
      acc[word].ses += Number(m.ses) || 0;
      acc[word].ch += Number(m.ch) || 0;
      acc[word].ch_c += Number(m.ch_c) || 0;
    }
  }
  // Порядок как в колонке "Разрез по utm_term": бэкенд сначала сортирует ключи
  // по алфавиту, затем устойчиво пересортировывает по ch убыванию
  // (stat-back/src/query/getStat.js:591-594), поэтому при равных ch слова идут
  // по алфавиту. Array.prototype.sort устойчив, так что повторяем в два прохода.
  const orderedWords = Object.keys(acc).sort().sort((a, b) => acc[b].ch - acc[a].ch);
  const out = Object.create(null);
  for (const word of orderedWords) {
    const { ses, ch, ch_c } = acc[word];
    out[word] = {
      ses: ses,
      ch: ch,
      ch_p: percent(ch, ses),
      ch_c: ch_c,
      ch_p_c: percent(ch_c, ses),
    };
  }
  return out;
}

export function filterWordsByMinSessions(words, minSessions) {
  const min = Number(minSessions) || 0;
  if (min <= 0) return words;
  // Object.create(null) — по той же причине, что и в aggregateWords: word
  // может быть "__proto__", и обычный {} превратил бы присваивание в
  // переустановку прототипа вместо добавления ключа.
  const out = Object.create(null);
  for (const word of Object.keys(words)) {
    if (words[word].ses >= min) out[word] = words[word];
  }
  return out;
}

// Порядок фраз НЕ трогаем: бэкенд уже отдал utm-объект отсортированным по ch
// убыванию (stat-back/src/query/getStat.js:591-600), а порядок ключей объекта
// переживает JSON. Своя сортировка здесь сломала бы совпадение с колонкой
// "Разрез по utm_term", ради которого модалка и нужна.
export function findPhrasesWithWord(utmObj, word) {
  const target = String(word == null ? '' : word).trim().toLowerCase();
  return Object.keys(utmObj || {})
    .filter(phrase => splitPhraseToWords(phrase).includes(target))
    .map(phrase => ({ phrase: phrase, metrics: utmObj[phrase] }));
}

export function formatMetrics(metrics) {
  return Object.keys(metrics || {})
    .map(key => `${key}:${metrics[key]}`)
    .join(', ');
}
